import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ФИО"),
    /*#__PURE__*/_createElementVNode("th", null, "Дата рождения"),
    /*#__PURE__*/_createElementVNode("th", null, "Данные документа"),
    /*#__PURE__*/_createElementVNode("th", null, "Адрес регистрации"),
    /*#__PURE__*/_createElementVNode("th", null, "MO"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    class: "text-center font-weight-bold"
  }, "Нет данных")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "mt-5" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Вы собираетесь добавить", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "В качестве иждивенца для", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Вы собираетесь удалить", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Из иждивенцев у", -1)

import { CitizensService, Citizen, citizenGetFullname, citizenGetAddress, CitizenFullInfo } from '@prodcard/core'
import { VCitizenFullInfoSelect } from '../../../../components'
import { createCtx, handleError, callSuccessToast } from '../../../../helpers'
import { ref, Ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CitizenDependentsTab',
  props: {
    citizensService: {},
    citizen: {}
  },
  setup(__props: any) {

const props = __props;



const loading = ref(false)
const dependentsInfo: Ref<CitizenFullInfo[]> = ref([])
const newDependent: Ref<CitizenFullInfo | undefined> = ref(undefined)
const dependentToDelete: Ref<CitizenFullInfo | undefined> = ref(undefined)
const showDeleteConfirmation = ref(false)
const showAddDialog = ref(false)

handleError(async () => {
  if (props.citizen.dependentIds) {
    dependentsInfo.value = (
      await props.citizensService.findAllWithInfo(createCtx(), { filter: { ids: props.citizen.dependentIds } })
    ).items
  }
}, loading)

const addDependent = (dependentInfo?: CitizenFullInfo) => {
  showAddDialog.value = false
  if (!dependentInfo) {
    return
  }
  handleError(async () => {
    await props.citizensService.addDependent(createCtx(), dependentInfo.citizen.id, props.citizen.id)
    dependentsInfo.value.push(dependentInfo)
    newDependent.value = undefined
    callSuccessToast('Данные гражданина обновлены')
  }, loading)
}

const deleteDependent = (dependentInfo?: CitizenFullInfo) => {
  showDeleteConfirmation.value = false
  if (!dependentInfo) {
    return
  }
  handleError(async () => {
    await props.citizensService.removeDependent(createCtx(), dependentInfo.citizen.id, props.citizen.id)
    const depId = dependentsInfo.value.indexOf(dependentInfo)
    dependentsInfo.value.splice(depId, 1)
    dependentToDelete.value = undefined
    callSuccessToast('Данные гражданина обновлены')
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loading.value)
      ? (_openBlock(), _createBlock(_component_v_sheet, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table, { hover: "" }, {
              default: _withCtx(() => [
                _hoisted_1,
                (dependentsInfo.value.length > 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dependentsInfo.value, (dependentInfo) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          key: dependentInfo.citizen.id,
                          to: { path: `/citizens/${dependentInfo.citizen.id}/edit` },
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("tr", {
                              onClick: navigate,
                              style: {"cursor":"pointer"}
                            }, [
                              _createElementVNode("td", null, _toDisplayString(_unref(citizenGetFullname)(dependentInfo.citizen)), 1),
                              _createElementVNode("td", null, _toDisplayString(dependentInfo.citizen.birthdate.toLocaleDateString()), 1),
                              _createElementVNode("td", null, _toDisplayString(dependentInfo.document.info), 1),
                              _createElementVNode("td", null, _toDisplayString(_unref(citizenGetAddress)(dependentInfo.citizen)), 1),
                              _createElementVNode("td", null, _toDisplayString(dependentInfo.municipalEntity), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_btn, _mergeProps({ icon: "mdi-delete" }, props, {
                                  variant: "text",
                                  size: "small",
                                  onClick: _withModifiers(
                  () => {
                    dependentToDelete.value = dependentInfo
                    showDeleteConfirmation.value = true
                  }
                , ["stop"])
                                }), null, 16, ["onClick"])
                              ])
                            ], 8, _hoisted_3)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("tfoot", _hoisted_4, _hoisted_6))
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "mt-5",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddDialog.value = true)),
              variant: 'tonal'
            }, {
              default: _withCtx(() => [
                _createTextVNode("Добавить иждивенца")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
          key: 1,
          type: "heading@3, actions"
        })),
    _createVNode(_component_v_dialog, {
      modelValue: showAddDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showAddDialog).value = $event)),
      "max-width": 500
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "pa-5",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_actions, { class: "justify-end align-start pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {;(showAddDialog.value = false), (newDependent.value = undefined)})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Закрыть")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (!newDependent.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_unref(VCitizenFullInfoSelect), {
                    modelValue: newDependent.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newDependent).value = $event)),
                    "citizens-service": _ctx.citizensService,
                    except: [_ctx.citizen.id, ...dependentsInfo.value?.map(d => d.citizen.id)],
                    label: "Новый иждивенец"
                  }, null, 8, ["modelValue", "citizens-service", "except"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      class: "text-primary text-decoration-underline text-body-2",
                      to: { path: '/citizens/new', query: { redirectToBack: 'true' } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Либо вы можете создать нового гражданина-иждивенца ")
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("strong", null, _toDisplayString(_unref(citizenGetFullname)(newDependent.value.citizen)) + " (" + _toDisplayString(newDependent.value.citizen.birthdate.toLocaleDateString()) + ")", 1),
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("strong", null, _toDisplayString(_unref(citizenGetFullname)(_ctx.citizen)) + " (" + _toDisplayString(_ctx.citizen.birthdate.toLocaleDateString()) + ")", 1),
                  _createVNode(_component_v_card_actions, { class: "justify-end mt-3 pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        variant: 'plain',
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (newDependent.value = undefined))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Назад")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        variant: 'tonal',
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (addDependent(newDependent.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Добавить")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showDeleteConfirmation.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showDeleteConfirmation).value = $event)),
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "pa-5",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_actions, { class: "justify-end align-start pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (showDeleteConfirmation.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Закрыть")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (dependentToDelete.value)
              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createElementVNode("strong", null, _toDisplayString(_unref(citizenGetFullname)(dependentToDelete.value.citizen)) + " (" + _toDisplayString(dependentToDelete.value.citizen.birthdate.toLocaleDateString()) + ")", 1),
                    _hoisted_14,
                    _hoisted_15,
                    _createElementVNode("strong", null, _toDisplayString(_unref(citizenGetFullname)(_ctx.citizen)) + " (" + _toDisplayString(_ctx.citizen.birthdate.toLocaleDateString()) + ")", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_actions, { class: "justify-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: 'tonal',
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (deleteDependent(dependentToDelete.value)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Удалить")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})